export enum ToggleButtonType {
  Vertical = 'vertical',
  Horizontal = 'horizontal',
  Text = 'text',
  Icon = 'icon',
}
